import { Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import {ConfigService} from '../../../core/_base/services/config.service';

@Component({
  selector: 'app-alert-spinner',
  templateUrl: './alert-spinner.component.html',
  styleUrls: [],
})
export class AlertSpinnerComponent implements OnInit {
  public mensaje: string='';
  constructor(private configS: ConfigService,
    @Inject(MAT_DIALOG_DATA) public data?: any) {}

  ngOnInit(): void {
    this.mensaje = this.data.mensaje;
    if (this.data.time) {
      setTimeout (() => {
        this.mensaje = this.configS.getValue('MENSAJE_ESPERA_VALIDA_ROSTRO');
      }, this.data.time);
    }
  }
}
